module.exports = __webpack_public_path__ + "static/media/Group3412.53d9a180.svg";